export type MinimalUserRef = { id?: string; uid?: string; username?: string | null | undefined };

/**
 * Returns the canonical profile URL.
 * - Prefer /:username when available
 * - Fallback to /profile/:uid
 */
export function getProfileUrl(u: MinimalUserRef): string {
  const username = (u.username || '').toString().trim();
  // Ignore display names or placeholders that aren't valid handles; the uid route always resolves.
  if (/^[A-Za-z0-9._-]+$/.test(username) && username.toLowerCase() !== 'user') return `/${username}`;
  const id = (u.uid || u.id || '').toString().trim();
  return id ? `/profile/${id}` : '/profile';
}
